import { InjectableClass } from '@fino/lib-injection';

export class ControllerService extends InjectableClass {
  constructor(
    $log,
    $locale,
    $location,
    $translate,
    $state,
    $stateParams,
    $timeout,
    $window,
    appConfig,
    appCache,
    appService,
    authService,
    envService,
    errorService,
    errorTrackingService,
    tmhDynamicLocale,
    userService,
    featureFlagService
  ) {
    'ngInject';
    super({
      $log,
      $locale,
      $location,
      $translate,
      $state,
      $stateParams,
      $timeout,
      $window,
      appConfig,
      appCache,
      appService,
      authService,
      envService,
      errorService,
      errorTrackingService,
      tmhDynamicLocale,
      userService,
      featureFlagService,
    });
  }
}
